import {Dispatch, useReducer, type PropsWithChildren} from "react";
import {createContext} from "../../../../context/create-context";
import {type Error, HandleQuery} from "../../../../common/handle-query";
import {GetDiscountsApiResponse} from "../types";
import {useGetDiscountCodes} from "../../../../react-query-hooks/discounts/discounts";
import {
  GetDiscountCodesActions,
  GetDiscountCodesState,
  getDiscountCodesReducer,
  initialGetDiscountCodesState,
} from "../reducers/get-discount-codes.reducer";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {FullPageLoader} from "../../../../components/full-page-loader";
import {Alert} from "antd";

type GetDiscountCodesContextState = {
  state: GetDiscountCodesState;
  dispatch: Dispatch<GetDiscountCodesActions>;
};

const [useContext, ContextProvider] = createContext<GetDiscountCodesContextState>();

export const useGetDiscountCodesContext = useContext;

export const GetDiscountCodesProvider = ({children}: PropsWithChildren) => {
  const [reducerState, dispatch] = useReducer(
    getDiscountCodesReducer,
    initialGetDiscountCodesState
  );
  return (
    <HandleQuery<GetDiscountsApiResponse, Error>
      query={useGetDiscountCodes(reducerState.currentPage, reducerState.per_page)}
      loader={
        <DashboardWrapper pageTitle={"Discounts"}>
          <FullPageLoader />
        </DashboardWrapper>
      }
      errorView={(err) => (
        <DashboardWrapper pageTitle={"Discounts"}>
          <Alert message="Error" description={err.message} type="error" showIcon />
        </DashboardWrapper>
      )}
      children={(queryResult) => {
        return (
          <ContextProvider
            value={{
              state: {
                currentPage: reducerState.currentPage,
                isLoading: queryResult.isLoading,
                isFetching: queryResult.isFetching,
                isPreviousData: queryResult.isPreviousData,
                per_page: reducerState.per_page,
                discountCodes: queryResult.data.data.discounts,
                discountCodesMeta: queryResult.data.meta,
              },
              dispatch,
            }}
          >
            {children}
          </ContextProvider>
        );
      }}
    />
  );
};
